import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=677ffd00&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=677ffd00&lang=scss&scoped=true"
import style1 from "./Main.vue?vue&type=style&index=1&id=677ffd00&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677ffd00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('677ffd00')) {
      api.createRecord('677ffd00', component.options)
    } else {
      api.reload('677ffd00', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=677ffd00&scoped=true", function () {
      api.rerender('677ffd00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/App/Main.vue"
export default component.exports